import { AbstractControl, ValidationErrors } from '@angular/forms';
import {
  startOfDay,
  startOfWeek,
  startOfMonth,
  endOfWeek,
  endOfMonth,
  addHours,
  isSameDay,
} from 'date-fns';

export class DateValidators {
  static minStartDateValidator(
    control: AbstractControl
  ): ValidationErrors | null {
    const startDateTime = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (startDateTime < today) {
      return { minStartDate: true };
    }
    return null;
  }

  static applyDateFilter(filterValue: string): {
    startDate: Date;
    endDate: Date;
  } {
    let startDate, endDate: Date;
    switch (filterValue) {
      case 'today':
        startDate = startOfDay(new Date());
        endDate = addHours(startOfDay(new Date()), 12);
        break;
      case 'thisWeek':
        startDate = startOfWeek(new Date(), { weekStartsOn: 1 });
        endDate = endOfWeek(new Date(), { weekStartsOn: 1 });
        break;
      case 'thisMonth':
        startDate = startOfMonth(new Date());
        endDate = endOfMonth(new Date());
        break;
      default:
        startDate = endDate = new Date();
    }
    return { startDate, endDate };
  }
  static isActiveFilter(
    filterValue: string,
    startDateStr: string,
    endDateStr: string
  ): boolean {
    const startDate = startDateStr ? new Date(startDateStr) : null;
    const endDate = endDateStr ? new Date(endDateStr) : null;
    if (!startDate || !endDate) return false;

    switch (filterValue) {
      case 'today': {
        return (
          isSameDay(startDate, new Date()) && isSameDay(endDate, new Date())
        );
      }
      case 'thisWeek': {
        const startOfWeekDate = startOfWeek(new Date(), { weekStartsOn: 1 });
        const endOfWeekDate = endOfWeek(new Date(), { weekStartsOn: 1 });
        return (
          isSameDay(startDate, startOfWeekDate) &&
          isSameDay(endDate, endOfWeekDate)
        );
      }
      case 'thisMonth': {
        const startOfMonthDate = startOfMonth(new Date());
        const endOfMonthDate = endOfMonth(new Date());
        return (
          isSameDay(startDate, startOfMonthDate) &&
          isSameDay(endDate, endOfMonthDate)
        );
      }
      default:
        return false;
    }
  }
}
